import { render, staticRenderFns } from "./orgExam.vue?vue&type=template&id=637315e8&scoped=true&"
import script from "./orgExam.vue?vue&type=script&lang=js&"
export * from "./orgExam.vue?vue&type=script&lang=js&"
import style0 from "./orgExam.vue?vue&type=style&index=0&id=637315e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637315e8",
  null
  
)

export default component.exports